import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, STAFF_ROLES, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import ClientPortal from "@/pages/ClientPortal";
import StaffDashboard from "@/pages/StaffDashboard";
import StaffReports from "@/pages/StaffReports";
import StaffInvoices from "@/pages/StaffInvoices";
import StaffAdmin from "@/pages/StaffAdmin";
import "@/App.css";

function Gate({ children, staffOnly = false }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="app-shell flex items-center justify-center">
        <p className="font-display text-lg tracking-[0.3em] text-gold animate-pulse">VINEFORD</p>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (staffOnly && !STAFF_ROLES.includes(user.role)) return <Navigate to="/portal" replace />;
  if (!staffOnly && STAFF_ROLES.includes(user.role)) return <Navigate to="/staff" replace />;
  return children;
}

function LoginRoute() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to={STAFF_ROLES.includes(user.role) ? "/staff" : "/portal"} replace />;
  return <Login />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "rgba(10,25,47,0.92)",
              border: "1px solid rgba(212,175,55,0.35)",
              color: "#F3F4F6",
              backdropFilter: "blur(14px)",
            },
          }}
        />
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route
            path="/portal"
            element={
              <Gate>
                <ClientPortal />
              </Gate>
            }
          />
          <Route
            path="/staff"
            element={
              <Gate staffOnly>
                <StaffDashboard />
              </Gate>
            }
          />
          <Route
            path="/staff/reports"
            element={
              <Gate staffOnly>
                <StaffReports />
              </Gate>
            }
          />
          <Route
            path="/staff/invoices"
            element={
              <Gate staffOnly>
                <StaffInvoices />
              </Gate>
            }
          />
          <Route
            path="/staff/admin"
            element={
              <Gate staffOnly>
                <StaffAdmin />
              </Gate>
            }
          />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
